module.exports = __webpack_public_path__ + "img/Background.ccccc713.png";